import { FormDropdown } from "../../../../components/general/FormDropdown.tsx";
import { QuinnPromptOption } from "../../types";

type QuinnPromptDropdownProps = {
    options: QuinnPromptOption[];
    value: string;
    disabled: boolean;
    onSelect: (value: string) => void;
};

export function QuinnPromptDropdown({ options, value, disabled, onSelect }: QuinnPromptDropdownProps) {
    return (
        <div className="mt-2.5">
            <FormDropdown
                options={options.map((option) => ({ value: option.value, label: option.label }))}
                value={value}
                onChange={(next) => onSelect(String(next))}
                placeholder="Kies een klant"
                searchable
                disabled={disabled}
            />
        </div>
    );
}
